import { Layout, Menu } from "antd";
// import { useState } from "react";
import { useHistory } from "react-router-dom";
// import ShopForBuyer from "../ShopForBuyer";
// import { useNavigate } from "react-router-dom";
// import { useMediaQuery } from "react-responsive";
// import HelpFeedback from "./HelpFeedback";

const { Sider } = Layout;
const { SubMenu } = Menu;

const LogisticsSideNav = ({ currentPageKey }) => {
  // const navigate = useNavigate();
  // const isTabletOrMobile = useMediaQuery({ maxWidth: 640 });
  const history = useHistory();

  // const [shopBuyerModalVisible, setShopBuyerModalVisible] = useState(false);

  // const [sideNavFeedbackVisible, setSideNavFeedbackVisible]=useState(false)

  return (
    <div>
      <Sider className="sider seller-sidenav" style={{ marginTop: 60 }}>
        <Menu theme="dark" mode="inline" defaultSelectedKeys={[currentPageKey]}>
          <Menu.Item
            className="menu-item"
            key="1"
            // onClick={() => history.push("/finance-dashboard")}
            icon={
              <svg
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M20.1667 7.80998V3.64831C20.1667 2.35581 19.58 1.83331 18.1225 1.83331H14.4192C12.9617 1.83331 12.375 2.35581 12.375 3.64831V7.80081C12.375 9.10248 12.9617 9.61581 14.4192 9.61581H18.1225C19.58 9.62498 20.1667 9.10248 20.1667 7.80998Z"
                  fill="#800000"
                />
                <path
                  d="M20.1667 18.1225V14.4192C20.1667 12.9617 19.58 12.375 18.1225 12.375H14.4192C12.9617 12.375 12.375 12.9617 12.375 14.4192V18.1225C12.375 19.58 12.9617 20.1667 14.4192 20.1667H18.1225C19.58 20.1667 20.1667 19.58 20.1667 18.1225Z"
                  fill="black"
                />
                <path
                  d="M9.62492 7.80998V3.64831C9.62492 2.35581 9.03825 1.83331 7.58075 1.83331H3.87742C2.41992 1.83331 1.83325 2.35581 1.83325 3.64831V7.80081C1.83325 9.10248 2.41992 9.61581 3.87742 9.61581H7.58075C9.03825 9.62498 9.62492 9.10248 9.62492 7.80998Z"
                  fill="black"
                />
                <path
                  d="M9.62492 18.1225V14.4192C9.62492 12.9617 9.03825 12.375 7.58075 12.375H3.87742C2.41992 12.375 1.83325 12.9617 1.83325 14.4192V18.1225C1.83325 19.58 2.41992 20.1667 3.87742 20.1667H7.58075C9.03825 20.1667 9.62492 19.58 9.62492 18.1225Z"
                  fill="#800000"
                />
              </svg>
            }
          >
            Dashboard
          </Menu.Item>
          {/* <Menu.Item
            className="menu-item"
            onClick={() => history.push("/find-buyer")}
            key="14"
            icon={
              <svg
                width="22"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16.9287 18.5L12.1162 13.3051L7.78271 14.8186L2.72083 13.1269L0 8.77782L0.895607 3.80634L4.98819 0.53724L10.3618 0.5L14.5026 3.7159L15.4719 8.67408L14.4006 10.4456L13.1705 9.78861L13.9868 8.44L13.2017 4.43143L9.85451 1.83264L5.51252 1.8619L2.20784 4.50325L1.48229 8.52246L3.68162 12.0363L7.77137 13.4035L12.5442 11.7384L18 17.6275L16.9287 18.5Z"
                  fill="#6B1214"
                />
              </svg>
            }
          >
            Find Customer
          </Menu.Item> */}

          <SubMenu
            className="menu-item"
            key="2"
            icon={
              <svg
                width="22"
                height="18"
                viewBox="0 0 25 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2.84724 8.18493L2.11877 8.81153L1.72351 8.83601L0.97206 8.02094L0.99504 7.60239L1.55116 6.77509C1.41247 6.50839 1.30445 6.22487 1.22944 5.93065L0.294146 5.77155L0 5.49007V4.35926L0.294146 4.07778L1.23863 3.91624C1.31598 3.62214 1.42713 3.33933 1.56954 3.07425L1.01572 2.25673L0.992742 1.83574L1.74419 1.03535L2.13945 1.05983L2.91618 1.65216C3.17348 1.52197 3.4392 1.41154 3.71129 1.32173L3.85836 0.313299L4.12034 0H5.18432L5.44629 0.313299L5.60256 1.31928C5.8778 1.40211 6.1425 1.52048 6.39077 1.67174L7.15831 1.08186L7.55127 1.05738L8.30502 1.85776L8.27285 2.27876L7.71443 3.10606C7.85585 3.37224 7.96621 3.65582 8.04305 3.9505L8.97604 4.1096L9.27248 4.38863V5.52189L8.98064 5.80092L8.04305 5.96736C7.95078 6.25569 7.84022 6.537 7.71213 6.80936L8.27285 7.62442L8.29583 8.04297L7.54208 8.8458L7.13763 8.81153L6.3609 8.21675C6.12315 8.36397 5.87022 8.48142 5.60715 8.56677L5.41872 9.57275L5.15444 9.8885H4.09276L3.82849 9.57275L3.67682 8.56677C3.39215 8.46058 3.11492 8.33298 2.84724 8.18493Z"
                  fill="#6B1214"
                />
                <path
                  d="M5.31524 6.82158L4.02146 6.84606L3.01493 5.97714L2.76904 4.62359L3.3964 3.4169L4.60516 2.92493L5.83 3.37529L6.49642 4.55751L6.2919 5.9184L5.31524 6.82158Z"
                  fill="white"
                />
                <path
                  d="M14.1832 14.7447L13.5122 14.5758L16.0837 3.00086L15.5988 2.34489H9.35742V1.6106H15.7643L16.0354 1.75011L16.7272 2.68267L16.7938 2.99597L14.1832 14.7447Z"
                  fill="#010101"
                />
                <path
                  d="M2.92073 15.2513L2.57373 14.8401L3.02644 10.8847L3.71125 10.9728L3.3045 14.5097L3.93415 14.4999L3.94564 15.2342L2.92073 15.2513Z"
                  fill="#010101"
                />
                <path
                  d="M15.0996 14.4365L12.6223 14.4893L12.6361 15.2236L15.1134 15.1708L15.0996 14.4365Z"
                  fill="#010101"
                />
                <path
                  d="M23.18 15.0481L23.1708 14.3138H23.3156L24.2923 8.02095L22.4929 5.75932H15.9275V5.02502H22.6515L22.9157 5.15475L24.9219 7.67583L25 7.97199L23.9476 14.7348L23.612 15.0432L23.18 15.0481Z"
                  fill="#010101"
                />
                <path
                  d="M8.07989 18L7.85009 17.9706L6.24148 17.1066L6.08062 16.9255L5.36364 15.1558L5.34985 14.9111L5.8692 13.0656L6.00938 12.8648L7.52148 11.8075L7.75128 11.7487L9.54832 11.9715L9.75974 12.084L10.9984 13.4865L11.0926 13.7166L11.1983 15.638L11.1294 15.8828L10.0516 17.4273L9.85396 17.5668L8.07989 18ZM6.66432 16.5118L8.05462 17.2461L9.5713 16.8619L10.4905 15.5328L10.4009 13.8782L9.33001 12.6813L7.78345 12.483L6.48277 13.396L6.03466 14.9845L6.66432 16.5118Z"
                  fill="#010101"
                />
                <path
                  d="M18.8804 18L18.6506 17.9706L17.042 17.1066L16.8812 16.9255L16.1642 15.1558L16.1504 14.9111L16.6697 13.0656L16.8099 12.8648L18.3197 11.8075L18.5495 11.7487L20.3443 11.9715L20.5557 12.084L21.7966 13.4865L21.8908 13.7166L21.9942 15.638L21.9276 15.8828L20.8475 17.4273L20.6499 17.5668L18.8804 18ZM17.4511 16.5118L18.8437 17.2461L20.3581 16.8619L21.2773 15.5328L21.1853 13.8782L20.1168 12.6715L18.5817 12.483L17.281 13.4009L16.8352 14.9894L17.4511 16.5118Z"
                  fill="#010101"
                />
              </svg>
            }
            title="Suppliers"
          >
            <Menu.Item
              className="menu-item"
              onClick={() => history.push("/all-suppliers-logistics")}
              key="21"
            >
              All Suppliers
            </Menu.Item>
          </SubMenu>

          <SubMenu
            className="menu-item"
            key="3"
            icon={
              <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_12973_104780)">
              <path d="M9.5 0.59375C4.58137 0.59375 0.59375 4.58137 0.59375 9.5L0.594047 9.51573L0.59375 9.53147C0.59375 14.4329 4.55911 18.4062 9.45102 18.4062L9.47002 18.4057L9.5 18.4062C14.4186 18.4062 18.4062 14.4186 18.4062 9.5C18.4062 4.58137 14.4186 0.59375 9.5 0.59375ZM17.8125 9.5C17.8125 10.2107 17.7228 10.9004 17.5554 11.5585C17.4779 11.5051 17.2731 11.726 17.2226 11.4333C17.1594 11.0699 16.7497 10.8175 16.5291 10.9912C16.3085 11.1649 15.6783 11.6699 15.6471 11.9857C15.6153 12.3013 15.3472 12.6801 15.2217 12.4123C15.0952 12.144 14.7176 11.3071 14.733 11.0862C14.7485 10.8653 14.559 11.1652 14.2764 10.7231C13.9926 10.2811 13.5042 10.6596 13.1103 10.4387C12.7163 10.2175 12.2752 9.9177 12.0543 9.8233C11.8343 9.7283 12.4483 10.7071 12.5272 10.5809C12.6065 10.4548 12.9212 10.6756 13.0159 10.6756C13.1106 10.6756 13.3623 10.8965 13.205 11.1019C13.0477 11.3074 11.6455 12.1606 11.5036 11.9385C11.3611 11.7165 10.5269 9.99667 10.3847 10.1021C10.2428 10.2075 11.2673 12.0015 11.4407 12.1119C11.6135 12.2226 12.1339 12.1279 12.3856 12.0175C12.638 11.9071 11.8658 13.2489 11.5354 13.4069C11.2047 13.5645 10.9369 14.0541 11.0782 14.2749C11.2201 14.4958 11.2358 15.3327 10.9369 15.4434C10.637 15.5536 10.5269 15.7273 10.6213 15.9327C10.7154 16.1375 10.401 16.4846 10.2591 16.7057C10.1169 16.9266 9.56591 17.3844 9.51841 17.5109C9.4715 17.6373 8.79403 17.6056 8.52566 17.6056C8.25817 17.6056 8.46272 17.274 8.43095 16.9902C8.40008 16.7057 8.16377 16.4374 8.16377 16.2955C8.16377 16.1533 8.0845 15.8217 7.97466 15.664C7.86452 15.5058 7.83245 15.2059 7.94289 15.0326C8.05362 14.8586 8.132 14.3539 7.91202 14.1327C7.69114 13.9119 7.4388 13.5328 7.61247 13.2329C7.78584 12.9331 7.42336 12.9648 7.12411 12.8223C6.82456 12.6801 6.21003 12.8698 5.89505 12.9173C5.57977 12.9645 5.26508 12.8384 5.17037 12.6801C5.07597 12.5225 4.87113 12.1279 4.66123 12.0329C4.45194 11.9385 4.57188 11.528 4.69775 11.3703C4.82422 11.2127 4.57188 10.9125 4.69775 10.7858C4.82422 10.6596 4.90259 10.2021 5.15464 10.1021C5.40698 10.0023 5.35948 9.93373 5.3672 9.69683C5.37522 9.45992 5.65072 9.45992 5.69762 9.33375C5.74512 9.20728 5.88673 9.14434 6.17114 9.14434C6.45466 9.14434 6.9347 8.97839 7.1633 8.92317C7.39189 8.86795 7.78584 8.78898 7.75408 9.01016C7.72261 9.23103 7.73062 9.48338 7.87995 9.48338C8.02987 9.48338 8.23472 9.57036 8.47103 9.71761C8.70734 9.86456 8.71506 9.74433 8.74683 9.57837C8.77859 9.41242 9.10902 9.47566 9.45102 9.63359C9.79302 9.79153 10.2594 9.6808 10.4084 9.66536C10.5584 9.64903 10.6216 9.19956 10.5821 9.04964C10.5423 8.89972 10.3063 9.12059 10.1567 9.02589C10.0071 8.93148 9.80192 9.04964 9.65259 8.91516C9.50267 8.78127 9.47892 8.46539 9.65259 8.45767C9.82567 8.44966 9.91266 8.39444 10.0148 8.27628C10.1175 8.15783 10.5034 8.08687 10.6531 8.20503C10.8024 8.32348 11.0236 8.40245 11.1569 8.26827C11.2908 8.13438 10.8897 7.87402 10.8024 7.80277C10.7157 7.73181 10.7867 7.50292 10.7003 7.50292C10.6133 7.50292 10.5423 7.54211 10.5898 7.65284C10.637 7.76328 10.3378 7.96041 10.29 7.85027C10.2431 7.73953 10.1644 7.52667 10.0463 7.52667C9.92839 7.52667 9.77075 8.06342 9.76273 8.15011C9.75472 8.23709 9.54988 8.379 9.38481 8.379C9.21975 8.379 9.21975 8.5687 9.30614 8.65569C9.39283 8.74238 9.32959 9.08972 9.17225 9.10961C9.01461 9.1298 8.95939 9.07398 8.93594 8.9395C8.91248 8.80561 8.75484 8.82134 8.74683 8.54495C8.73881 8.26856 8.56544 8.13467 8.4553 8.0082C8.34516 7.88173 8.06134 7.51094 7.9512 7.67689C7.84106 7.84284 8.34516 8.19791 8.47875 8.29231C8.61323 8.38702 8.58948 8.59216 8.51853 8.63966C8.44758 8.68716 8.31369 9.07398 8.23502 9.10516C8.15575 9.13663 8.08064 8.98759 8.08064 8.98759C7.96248 8.94039 8.2457 8.79819 8.2932 8.72723C8.34011 8.65628 7.79712 8.15902 7.69916 8.01681C7.60119 7.87461 7.18259 8.13497 6.99378 8.04056C6.80467 7.94616 6.52086 8.39563 6.4977 8.65598C6.47366 8.91664 6.16639 8.9873 5.88287 8.9873C5.59966 8.9873 5.41025 8.77444 5.50525 8.56128C5.59966 8.34812 5.45775 7.99306 5.62341 7.96931C5.78877 7.94586 6.2608 7.96931 6.3555 7.70895C6.44991 7.44859 5.90633 7.21169 6.11948 7.16448C6.33175 7.11698 6.66306 6.78597 6.89937 6.59627C7.13509 6.40686 7.15884 6.17025 7.37141 6.15363C7.58456 6.1373 7.3245 5.74364 7.51361 5.62548C7.70302 5.50703 7.74992 6.0518 7.89183 6.0518C8.03373 6.0518 8.31666 6.0043 8.55327 6.12275C8.78988 6.2412 8.86053 6.0043 8.95523 5.69614C9.04964 5.38858 9.28595 5.22263 9.75828 4.98602C10.2309 4.74911 9.2153 5.05697 9.02589 4.82006C8.83678 4.58316 9.09684 4.06214 9.2153 3.69431C9.33345 3.32619 8.83708 4.06214 8.57702 4.44125C8.31666 4.82006 8.64797 4.98572 8.62392 5.24608C8.60047 5.50673 8.17564 5.8143 8.17564 5.8143C7.98653 5.83805 8.00998 5.45923 7.91558 5.29358C7.82088 5.12792 7.65522 5.19887 7.39516 5.38828C7.13509 5.57769 7.11164 4.93852 7.04098 4.67786C6.97062 4.4178 7.46641 4.08589 7.69945 3.90895C7.9322 3.73142 8.31666 2.8785 8.74238 2.21588C9.16809 1.55295 9.78233 1.88427 9.94769 2.14492C10.1136 2.40498 10.5382 2.23933 10.9404 2.71314C11.3424 3.18666 10.8457 3.39952 10.3975 3.20714C9.94769 3.01477 10.4916 3.68392 10.751 3.87333C11.0111 4.06244 11.153 3.44702 11.2477 3.30511C11.3421 3.16291 11.6963 3.23416 11.956 2.85505C12.2164 2.47623 12.8069 2.54748 13.1441 2.58905C13.4817 2.63091 13.3977 2.38153 13.1851 2.17758C13.0278 2.02677 13.3496 2.15887 13.7284 2.34383C16.1726 3.7905 17.8125 6.45317 17.8125 9.5ZM5.94997 6.67138C5.87159 6.59033 6.02923 6.27119 6.09989 6.17648C6.17114 6.08178 5.90277 6.11325 5.91909 6.24773C5.93483 6.38163 5.81637 6.58706 5.65102 6.64228C5.48566 6.6975 5.29714 6.68147 5.39125 6.53155C5.48536 6.38162 5.39897 6.24744 5.32802 6.10523C5.25736 5.96303 5.72167 5.87634 5.81667 5.78966C5.91108 5.70297 5.66734 5.64745 5.67477 5.51356C5.68278 5.37908 5.738 5.26092 5.83181 5.24519C5.92652 5.22945 6.01498 5.16889 6.09989 5.17423C6.36025 5.19027 6.28069 5.78194 6.37569 5.97164C6.47009 6.16075 6.73817 6.38994 6.71442 6.5553C6.69067 6.72125 6.6402 6.81595 6.44723 6.76845C6.25337 6.72095 5.94314 7.01308 5.82439 6.95786C5.70594 6.90234 6.02923 6.75242 5.94997 6.67138ZM4.25244 3.35202C4.48905 3.47017 4.67756 3.25583 4.84263 3.20981C5.03827 3.15578 5.14989 3.84928 4.96108 3.82553C4.77197 3.80178 4.55941 4.20434 4.28628 4.18059C4.01286 4.15684 4.13398 3.96773 3.82672 3.68362C3.76081 3.62247 3.7338 3.56725 3.73142 3.51886C3.79703 3.45562 3.86234 3.39209 3.93033 3.33123C4.03661 3.30303 4.16278 3.30719 4.25244 3.35202ZM11.6452 15.2689C11.8658 15.2217 11.8233 14.8019 12.0234 14.7796C12.4489 14.7324 12.0392 15.9161 11.8818 16.2477C11.7242 16.5793 11.6607 16.5633 11.5107 16.3581C11.3602 16.1533 11.4089 15.8214 11.5107 15.6637C11.6123 15.5055 11.4243 15.3164 11.6452 15.2689Z" fill="#6B1214"/>
              </g>
              <defs>
              <clipPath id="clip0_12973_104780">
              <rect width="19" height="19" fill="white"/>
              </clipPath>
              </defs>
              </svg>

            }
            title="Inter-Country"
          >
            <Menu.Item
              className="menu-item"
              // onClick={() => history.push("/logistic-info/194")}
              key="31"
            >
              Nigeria
            </Menu.Item>
            <Menu.Item
              className="menu-item"
              // onClick={() => history.push("/manage-orders/all")}
              key="32"
            >
              United Kingdom
            </Menu.Item>

            <Menu.Item
              className="menu-item"
              // onClick={() => history.push("/manage-orders/flagged")}
              key="33"
            >
              United States
            </Menu.Item>
            
          </SubMenu>

          <SubMenu
            className="menu-item"
            key="4"
            icon={
              <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M17.4173 9.50065C17.4173 8.46102 17.2125 7.43157 16.8147 6.47107C16.4168 5.51058 15.8337 4.63785 15.0986 3.90272C14.3635 3.16759 13.4907 2.58445 12.5302 2.1866C11.5697 1.78876 10.5403 1.58398 9.50065 1.58398C7.40102 1.58398 5.38739 2.41806 3.90272 3.90272C2.41806 5.38739 1.58398 7.40102 1.58398 9.50065C1.58398 11.6003 2.41806 13.6139 3.90272 15.0986C5.38739 16.5832 7.40102 17.4173 9.50065 17.4173C11.6003 17.4173 13.6139 16.5832 15.0986 15.0986C16.5832 13.6139 17.4173 11.6003 17.4173 9.50065ZM15.7786 8.70898H13.459C13.3284 6.8471 12.6905 5.05651 11.6144 3.53148C12.7199 3.92413 13.6947 4.61612 14.43 5.53032C15.1652 6.44451 15.6321 7.54497 15.7786 8.70898ZM7.18898 10.2923H11.8757C11.673 12.2482 10.8394 14.085 9.50065 15.5252C8.16279 14.091 7.34826 12.2472 7.18898 10.2923ZM7.18898 8.70898C7.37335 6.76293 8.18458 4.92934 9.50065 3.48398C10.8502 4.91383 11.6858 6.75202 11.8757 8.70898H7.18898ZM7.47398 3.50773C6.39221 5.04121 5.74403 6.83805 5.59773 8.70898H3.22273C3.37228 7.53059 3.85022 6.418 4.60195 5.49828C5.35368 4.57856 6.34891 3.88879 7.47398 3.50773ZM3.22273 10.2923H5.59773C5.72812 12.1617 6.37189 13.9587 7.45815 15.4857C6.33713 15.1027 5.34597 14.4131 4.59728 13.4951C3.84859 12.577 3.37237 11.4674 3.22273 10.2923ZM11.5748 15.4777C12.6581 13.9504 13.3091 12.1589 13.459 10.2923H15.7944C15.6447 11.4642 15.1702 12.5708 14.4245 13.4871C13.6789 14.4035 12.6918 15.093 11.5748 15.4777Z" fill="#6B1214"/>
              </svg>
            }
            title="Intra-Country"
          >
            <Menu.Item
              className="menu-item"
              // onClick={() => history.push("/manage-orders/all")}
              key="41"
              onClick={() => history.push("/logistic-info/7")}
            >
              Umuahia-Abala
            </Menu.Item>
            {/* <Menu.Item
              className="menu-item"
              // onClick={() => history.push("/manage-orders/all")}
              key="42"
            >
              United Kingdom
            </Menu.Item>

            <Menu.Item
              className="menu-item"
              // onClick={() => history.push("/manage-orders/flagged")}
              key="43"
            >
              United States
            </Menu.Item> */}
            
          </SubMenu>

          <SubMenu
            className="menu-item"
            key="5"
            icon={
              <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M17.4173 9.50065C17.4173 8.46102 17.2125 7.43157 16.8147 6.47107C16.4168 5.51058 15.8337 4.63785 15.0986 3.90272C14.3635 3.16759 13.4907 2.58445 12.5302 2.1866C11.5697 1.78876 10.5403 1.58398 9.50065 1.58398C7.40102 1.58398 5.38739 2.41806 3.90272 3.90272C2.41806 5.38739 1.58398 7.40102 1.58398 9.50065C1.58398 11.6003 2.41806 13.6139 3.90272 15.0986C5.38739 16.5832 7.40102 17.4173 9.50065 17.4173C11.6003 17.4173 13.6139 16.5832 15.0986 15.0986C16.5832 13.6139 17.4173 11.6003 17.4173 9.50065ZM15.7786 8.70898H13.459C13.3284 6.8471 12.6905 5.05651 11.6144 3.53148C12.7199 3.92413 13.6947 4.61612 14.43 5.53032C15.1652 6.44451 15.6321 7.54497 15.7786 8.70898ZM7.18898 10.2923H11.8757C11.673 12.2482 10.8394 14.085 9.50065 15.5252C8.16279 14.091 7.34826 12.2472 7.18898 10.2923ZM7.18898 8.70898C7.37335 6.76293 8.18458 4.92934 9.50065 3.48398C10.8502 4.91383 11.6858 6.75202 11.8757 8.70898H7.18898ZM7.47398 3.50773C6.39221 5.04121 5.74403 6.83805 5.59773 8.70898H3.22273C3.37228 7.53059 3.85022 6.418 4.60195 5.49828C5.35368 4.57856 6.34891 3.88879 7.47398 3.50773ZM3.22273 10.2923H5.59773C5.72812 12.1617 6.37189 13.9587 7.45815 15.4857C6.33713 15.1027 5.34597 14.4131 4.59728 13.4951C3.84859 12.577 3.37237 11.4674 3.22273 10.2923ZM11.5748 15.4777C12.6581 13.9504 13.3091 12.1589 13.459 10.2923H15.7944C15.6447 11.4642 15.1702 12.5708 14.4245 13.4871C13.6789 14.4035 12.6918 15.093 11.5748 15.4777Z" fill="#6B1214"/>
              </svg>
            }
            title="Intra-State"
          >
            {/* <Menu.Item
              className="menu-item"
              // onClick={() => history.push("/manage-orders/all")}
              key="51"
            >
              Nigeria
            </Menu.Item>
            <Menu.Item
              className="menu-item"
              // onClick={() => history.push("/manage-orders/all")}
              key="56"
            >
              United Kingdom
            </Menu.Item>

            <Menu.Item
              className="menu-item"
              // onClick={() => history.push("/manage-orders/flagged")}
              key="57"
            >
              United States
            </Menu.Item> */}
            
          </SubMenu>

        </Menu>
      </Sider>

      {/* <ShopForBuyer
        shopBuyerModalVisible={shopBuyerModalVisible}
        setShopBuyerModalVisible={setShopBuyerModalVisible}
      /> */}

      {/* <HelpFeedback sideNavFeedbackVisible={sideNavFeedbackVisible} setSideNavFeedbackVisible={setSideNavFeedbackVisible} /> */}

      <style>
        {`
            .seller-sidenav{
              font-family: 'DomaineSansText-Light';
            }

            .ant-menu-dark.ant-menu-inline, 
            .ant-menu-dark.ant-menu-vertical, 
            .ant-menu-dark.ant-menu-vertical-left, 
            .ant-menu-dark.ant-menu-vertical-right{
                background: white;
            }

            .ant-menu-item .ant-menu-item-icon + span, 
            .ant-menu-submenu-title .ant-menu-item-icon + span, 
            .ant-menu-item .anticon + span, 
            .ant-menu-submenu-title .anticon + span, .ant-menu-dark .ant-menu-item-selected 
            .ant-menu-item-icon + span, .ant-menu-dark
            .ant-menu-item-selected .anticon + span{
                color: black;
            }
            .ant-menu-dark.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item-selected {
                background-color: rgba(0, 0, 0, 0.04);
            }
            .ant-layout-sider{
                background:white;
                border-right: 1px solid #e4e4e4;
                height:100%;
                position:fixed

            }

            .ant-menu-dark.ant-menu-inline .ant-menu-item,
            .ant-menu-dark.ant-menu-inline .ant-menu-submenu-title {
              align-items: center; 
              color:#000;
              display: flex;
              padding: 16px;
              width: 100%;
            }
        
            .ant-menu-dark .ant-menu-sub,
            .ant-menu.ant-menu-dark .ant-menu-sub {
              background: #fff;
              color: #fff;
            }
            .ant-menu.ant-menu-dark .sub-item {
              background: #252525;
              color: #fff;
              margin: 1px;
            }
          
           .ant-menu-submenu-arrow::before,.ant-menu-submenu-arrow::after {
              background: #000 !important;
              margin:20%;
            }
            .ant-menu-dark.ant-menu-inline, .ant-menu-dark.ant-menu-vertical, .ant-menu-dark.ant-menu-vertical-left, .ant-menu-dark.ant-menu-vertical-right{
              margin-top:96px
            }
            .currency-map-menu .ant-menu-sub.ant-menu-inline > .ant-menu-item, .ant-menu-sub.ant-menu-inline > .ant-menu-submenu > .ant-menu-submenu-title{
              height: 48px;
              line-height: 22px;
              white-space: normal;
            }

            @media (max-width: 640px) {
              .ant-layout-sider{
                border-right: 0

              }
            }
            `}
      </style>
    </div>
  );
};

export default LogisticsSideNav;
